import React, { FC, useRef } from 'react';
// import PlanComponent from 'components/layouts/Plan';
import { Link } from 'react-router-dom';
import FaqComponent from 'components/layouts/Faq';
import Button from 'components/form/Button';
import Services from 'components/layouts/index/Services';
import { motion, useScroll, useSpring } from 'framer-motion';
import Carousel from 'components/layouts/Carousel';
import Features from 'components/layouts/index/Features';
import Testimonial from './Testimonial';
import Counter from 'components/layouts/Counter';
import Reveal from 'components/Reveal';

const faqsData = [
  {
    title: 'What is Blockchain?',
    text: 'A crypto investment platform is a website or app that allows you to buy, sell, and trade cryptocurrencies. These platforms typically offer a variety of features, such as Easy-to-use trading tools, A wide selection of cryptocurrencies to choose from etc.',
  },
  {
    title: 'How do I create an account on a crypto investment platform?',
    text: `To create an account on Blockchain, you will typically need to provide your name, email address. Once your account has been verified, you can deposit funds and start investing in cryptocurrencies.`,
  },
  {
    title: 'Does Blockchain offer signup bonus',
    text: `Yes we do, you get a $100 bonus for signing up.`,
  },
];

const AccountSetup = () => {
  return (
    // <Reveal>
    <div className="my-5 py-10">
      <p className="text-2xl"></p>
      <br />
      <div className="container mx-auto px-3 md:px-[100px]">
        <div className="px-2 py-12">
          <h4 className="text-[35px] md:text-[50px]">Steps to earn</h4>
          <p className="text-lg">Easy &amp; Secure</p>
          <br />
          <ol className="list-decimal pl-4">
            <li>First you will need to have an active wallet.</li>
            <li>Make payment for the plan you are interested in.</li>
            <li>Invest and earn. Just as simple as that!</li>
          </ol>
          <br />
          <Link to="/register">
            <Button className="rounded-md bg-black px-3 py-2 text-white">
              Get started
            </Button>
          </Link>
        </div>
        <div className="absolute -top-[40px] right-[5%] hidden w-[40%] rounded-md bg-white text-black lg:block">
          <img
            src="/assets/images/img_two.jpeg"
            alt="card_picture"
            className="h-[350px] w-full rounded-md object-cover"
          />
        </div>
      </div>
    </div>
    // </Reveal>
  );
};

const Index: FC = () => {
  window.document.title = 'Blockchain InvestmentLN';

  const ref = useRef(null);

  const { scrollYProgress: progress } = useScroll();
  const scaleX = useSpring(progress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div className="pb-5" ref={ref}>
      <motion.div className="progress bg-blue-500" style={{ scaleX }} />

      <Carousel />
      <Reveal>
        <div className="container my-8 mx-auto h-full px-5 pt-10 lg:h-[800px]">
          <h3 className="mb-4 text-2xl font-semibold">
            Welcome to <span className="text-blue-500">Blockchain</span>.
          </h3>
          <p className="my-2 w-full text-lg lg:w-[55%]">
            Welcome to Blockchain Capitalizer, where we believe in the
            transformative power of cryptocurrency. Our mission is to help you
            navigate the exciting world of blockchain investments. We leverage
            cutting-edge cryptographic technology to ensure the security and
            integrity of your investments. With us, you're not just a client,
            you're a pioneer in the next wave of financial prosperity. Together,
            let's capitalize on the future of finance!"
          </p>

          <br />
          <div className="my-10">
            <Features />
          </div>
        </div>
      </Reveal>

      <section className="relative bg-slate-100 px-5 py-2">
        {/* account setup */}
        <Reveal>
          <AccountSetup />
          <div className="container my-[10px] mx-auto px-5 py-8">
            <p className="my-5 text-center text-[40px]">Features</p>
            <br />
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
              <div className="flex flex-col gap-y-2 text-center">
                <img
                  src="https://ershemug.sirv.com/broker/undraw_designer_life_re_6ywf.svg"
                  alt="buy"
                  className="h-32"
                />
                <p className="text-xl"> Easy Buying and Selling</p>
                <p className="text-lg">
                  Seamlessly buy and sell cryptocurrencies with just a few
                  clicks, making it convenient to manage your investments.
                </p>
              </div>
              <div className="flex flex-col gap-y-2 text-center">
                <img
                  src="https://ershemug.sirv.com/broker/gold.svg"
                  alt="buy"
                  className="h-32"
                />
                <p className="text-xl">Secure Wallets</p>
                <p className="text-lg">
                  Rest easy knowing that your funds are stored in secure
                  wallets, protected by advanced encryption technology.
                </p>
              </div>
              <div className="flex flex-col gap-y-2 text-center">
                <img
                  src="https://ershemug.sirv.com/broker/undraw_online_transactions_-02-ka.svg"
                  alt="buy"
                  className="h-32"
                />
                <p className="text-xl">24/7 Customer Support</p>
                <p className="text-lg">
                  Have any questions or need assistance? Our dedicated customer
                  support team is available around the clock to help you out.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
      <br />
      <section
        className="container mx-auto px-5 pt-10"
        style={{
          backgroundImage: `url('/assets/images/world_image.webp')`,
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Reveal>
          <div className="w-full lg:w-[50%]">
            <h4 className="text-[40px]">
              Our best users are all over the world with wide coverage
            </h4>
            <br />
            <p className="text-lg">
              Our platform reaches people all over the world, hereby we are
              trusted as the best platform for crypto trading
            </p>
            <br />
            <div className="flex flex-row flex-wrap justify-between gap-x-4 md:gap-x-4">
              <div className="basis-1/3">
                <p className="text-[50px]">25M+</p>
                <p>
                  People who have joined{' '}
                  <span className="text-blue-500">Blockchain</span>
                </p>
              </div>
              <div className="basis-1/3">
                <div className="flex text-[50px]">
                  <Counter from={10} to={100} />+
                </div>
                <p>
                  Famous people trading on{' '}
                  <span className="text-blue-500">Blockchain</span>
                </p>
              </div>
              <div className="basis-full md:basis-1/3">
                <p className="text-[50px]">32</p>
                <p>Cooperation with big companies</p>
              </div>
            </div>
          </div>
        </Reveal>

        <br />
        <Reveal>
          <div className="text-center">
            <h3 className="mt-32 text-[40px]">We take care of our quality</h3>
            <p className="text-lg">
              We always provide our best quality for users
            </p>
          </div>
          <div className="mt-[60px] flex flex-col flex-wrap justify-center gap-y-4 md:flex-row">
            <div className="basis-1/3 cursor-pointer rounded-lg bg-slate-100 py-14 px-5 text-center hover:bg-slate-100 md:basis-1/2 md:bg-inherit lg:basis-1/3">
              <img
                src="/assets/icons/award.svg"
                alt="icon"
                className="mx-auto mb-5 h-[50px] w-[50px]"
              />
              <p className="my-3 text-xl font-semibold">
                Best trading platform
              </p>
              <p className="mx-auto w-[80%]">
                Chance to magnify your investment and really win big with
                super-low spreads to further up your profits.
              </p>
            </div>
            <div className="basis-1/3 cursor-pointer rounded-lg bg-slate-100 py-14 px-5 text-center hover:bg-slate-100 md:basis-1/2 md:bg-inherit lg:basis-1/3">
              <img
                src="/assets/icons/globe.svg"
                alt="icon"
                className="mx-auto mb-5 h-[50px] w-[50px]"
              />
              <p className="my-3 text-xl font-semibold">
                Comfortable ecosystem
              </p>
              <p className="mx-auto w-[80%]">
                Blockchain offers multiple platform options to cover the needs
                of each type of trader and investors
              </p>
            </div>
            <div className="basis-1/3 cursor-pointer rounded-lg bg-slate-100 py-14 px-5 text-center hover:bg-slate-100 md:basis-full md:bg-inherit lg:basis-1/3">
              <img
                src="/assets/icons/lock.svg"
                alt="icon"
                className="mx-auto mb-5 h-[50px] w-[50px]"
              />
              <p className="my-3 text-xl font-semibold">Trusted security</p>
              <p className="mx-auto w-[80%]">
                Blockchain is secured by 256 bits SSL security encryption to
                ensure that your information is completely protected from fraud.
              </p>
            </div>
          </div>
        </Reveal>
      </section>
      <br />

      <Services />

      {/* testimonials */}
      <Testimonial />
      {/* faq */}
      <div className="bg-slate-100 px-5 py-[70px]">
        <Reveal>
          <div className="w-full text-lg">
            <p className="mb-10 text-center text-3xl">FAQs</p>
            <div className="mx-auto flex w-full flex-col gap-y-5 rounded-md bg-white p-2 lg:w-1/2">
              {faqsData.map((item, index) => (
                <FaqComponent
                  key={index}
                  title={item.title}
                  answer={item.text}
                />
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default Index;
